import { render, staticRenderFns } from "./contactCandidate.vue?vue&type=template&id=35ab8797&scoped=true"
import script from "./contactCandidate.vue?vue&type=script&lang=js"
export * from "./contactCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab8797",
  null
  
)

export default component.exports